import React from 'react'
import { Link } from 'react-router-dom'
import './SchulteTable.css'
import Button from '../../Components/Button'
import Navbar from '../../Components/Navbar'
export default function SchulteHome() {
    return (
        <>
            <header>
                <Navbar />
            </header>
            <main className="main">
                <h2>Boost Your Brain's Execution Speed !</h2>
                <br></br>
                <h3>Choose your Level</h3>
                <br></br>
                <Link to="/schulteHome/easy"><Button btn="outer-button" number="Easy"></Button></Link>
                <Link to="/schulteHome/medium"><Button btn="outer-button" number="Medium"></Button></Link>
                <Link to="/schulteHome/hard"><Button btn="outer-button" number="Hard"></Button></Link>
                <Link to="/schulteHome/tutorial"><Button btn="outer-button" number="Tutorial"></Button></Link>
                <Link to="/"><Button btn="outer-button" number="Back to Home"></Button></Link>
            </main>
        </>
    )
}
